import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toggleStatusMultiple, fetchShippingLabels, exportOrders } from '../../features/orders/orderSlice';
import ButtonPrimary from '../style-components/ButtonPrimary';
import { MdOutlineLocalShipping, MdMoneyOff, MdOutlineAttachMoney } from "react-icons/md";
import { IoCloudDownloadOutline } from "react-icons/io5";
import { FaRegFileExcel } from "react-icons/fa";

import Spinner from '../Spinner';



function OrderList({ orders, unpaid, pagination, filters, onFiltersChange, onPageChange }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isLoading } = useSelector(state => state.order);

    const [selectedOrders, setSelectedOrders] = useState([]);
    const [shippedButtonTitle, setShippedButtonTitle] = useState("Atzīmēt kā izsūtīts");
    const { onlyNewOrders, onlyProcessingOrders, onlyMasterclassOrders } = filters;

    const selectAll = (e) => {
        if (e.target.checked) {
            setSelectedOrders(orders.map(order => order._id));
        } else {
            setSelectedOrders([]);
        }
    };

    const selectOrder = (e, id) => {
        if (e.target.checked) {
            setSelectedOrders([...selectedOrders, id]);
        } else {
            setSelectedOrders(selectedOrders.filter(orderId => orderId !== id));
        }
    };

    const getDateString = (date) => {
        const d = new Date(date);
        return `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1).toString().padStart(2, '0')}.${d.getFullYear()}`;
    };

    const getStatusString = (status) => {
        switch (status) {
            case 'unpaid': return 'Neapmaksāts';
            case 'new': return 'Jauns pasūtījums';
            case 'processing': return 'Apstrādē';
            case 'shipped': return 'Nosūtīts';
            case 'cancelled': return 'Atcelts';
            default: return '';
        }
    };

    const handleToggleProcessing = () => {
        if (selectedOrders.length === 0) return;
        const data = {
            ids: selectedOrders,
            status: 'processing'
        };
        dispatch(toggleStatusMultiple(data));
        dispatch(fetchShippingLabels(selectedOrders));
    };

    function handleToggleExport() {
        if (selectedOrders.length === 0) return;
        dispatch(exportOrders(selectedOrders));
    }

    const handleToggleShipped = () => {
        if (selectedOrders.length === 0) return;
        const data = {
            ids: selectedOrders,
            status: 'shipped'
        };
        dispatch(toggleStatusMultiple(data));
    };

    useEffect(() => {
        const ordersSelectedObjects = orders.filter(order => selectedOrders.includes(order._id));
        if (ordersSelectedObjects.length > 0) {
            // Check if all selected orders are digital
            const allDigital = ordersSelectedObjects.every(order => order.digital);
            const someDigital = ordersSelectedObjects.some(order => order.digital);
            setShippedButtonTitle(allDigital ? "Nosūtīt atsauksmi" : someDigital ? "Atsauksme meistarklasēm + Izsūtīts" : "Atzīmēt kā izsūtīts");
        } else {
            setShippedButtonTitle("Atzīmēt kā izsūtīts");
        }
    }, [selectedOrders, orders]);

    useEffect(() => {
        setSelectedOrders([]);
    }, [orders]);

    const formatPrice = (price) => {
        return (price / 100).toFixed(2) + '€';
    };


    if (!orders || isLoading) return <Spinner />;

    return (
        <div style={{ width: "100%" }} className='padding-20-bottom'>
            <h2 className='light'>Pasūtījumu Saraksts:</h2>
            <div className="order-controls padding-20-top flex gap-10 space-between">
                <div className="flex column gap-10">
                    <div className="flex gap-10">
                        <ButtonPrimary onClick={handleToggleExport}><FaRegFileExcel size={15} style={{marginBottom: "-3px", paddingRight: "10px"}}/>Eksportēt</ButtonPrimary>
                        <ButtonPrimary onClick={handleToggleProcessing}><IoCloudDownloadOutline size={15} style={{marginBottom: "-3px", paddingRight: "10px"}}/>Lejupielādēt ceļa karti</ButtonPrimary>
                        <ButtonPrimary onClick={handleToggleShipped}><MdOutlineLocalShipping size={15} style={{marginBottom: "-3px", paddingRight: "10px"}}/>{shippedButtonTitle}</ButtonPrimary>
                    </div>
                    <div className="flex gap-10 column">
                        <label>
                            <input
                                type="checkbox"
                                checked={onlyNewOrders}
                                onChange={() => {
                                    const nextValue = !onlyNewOrders;
                                    onFiltersChange({
                                        onlyNewOrders: nextValue,
                                        onlyProcessingOrders: false,
                                        onlyMasterclassOrders: false,
                                    });
                                }}
                            />
                            <span className="padding-10-left">Tikai jauni pasūtījumi</span>
                            
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                checked={onlyProcessingOrders}
                                onChange={() => onFiltersChange({
                                    onlyNewOrders: false,
                                    onlyProcessingOrders: !onlyProcessingOrders,
                                    onlyMasterclassOrders: false,
                                })}
                            />
                            <span className="padding-10-left">Tikai apstrādē</span>
                            
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                checked={onlyMasterclassOrders}
                                onChange={() => {
                                    const nextValue = !onlyMasterclassOrders;
                                    onFiltersChange({
                                        onlyNewOrders: false,
                                        onlyProcessingOrders: false,
                                        onlyMasterclassOrders: nextValue,
                                    });
                                }}
                            />
                            <span className="padding-10-left">Meistarklases</span>
                            
                        </label>
                    </div>
                </div>
                <div className="flex gap-10">
                    <ButtonPrimary onClick={() => unpaid ? navigate("/edit-orders") : navigate("/unpaid-orders")}>
                        {unpaid ? <MdOutlineAttachMoney size={15} style={{marginBottom: "-3px", paddingRight: "10px"}}/> : <MdMoneyOff size={15} style={{marginBottom: "-3px", paddingRight: "10px"}}/>}
                        {unpaid ? "Atpakaļ uz apmaksātajiem" : "Apskatīt neapmaksātos"}
                    </ButtonPrimary>
                </div>
            </div>
            <div className="flex space-between">
                <p className='padding-20-top'>Atzīmēti pasūtījumi: {selectedOrders.length}</p>
            </div>
            <table className='admin-edit-orders-table padding-10-top'>
                <thead>
                    <tr>
                        <th className='checkbox'><input type="checkbox" onChange={selectAll} checked={orders.length > 0 && selectedOrders.length === orders.length} /></th>
                        <th>Vārds Uzvārds</th>
                        <th>Preces</th>
                        <th>Datums</th>
                        <th>Statuss</th>
                        <th>Cena</th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map((order) => (
                        <tr key={order._id}>
                            <td className='checkbox'><input type="checkbox" checked={selectedOrders.includes(order._id)} onChange={(e) => selectOrder(e, order._id)} /></td>
                            <td className='title' onClick={() => navigate(`/edit-orders/${order._id}`)}>{order.client.firstName} {order.client.lastName}</td>
                            <td className='items'>
                                <ul>
                                    {order.orderItems.map((item, index) => (
                                        <li key={index}>
                                            <span className={item.quantity !== 1 ? "red-text" : ""}>{item.quantity}x</span> {item.name}
                                        </li>                                        
                                    ))}
                                </ul>
                            </td>
                            <td className='date'>{getDateString(order.createdAt)}</td>
                            <td className='status'>{getStatusString(order.status)}</td>
                            <td className='price'>{unpaid ? formatPrice(order.totalPrice) : formatPrice(order.payment.amount)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="coupon-pagination">
                <span>Pasūtījumi: {pagination.total}</span>
                <div className="pagination-controls">
                    <ButtonPrimary
                        text="Iepriekšējā"
                        onClick={() => onPageChange(pagination.page - 1)}
                        disabled={pagination.page <= 1}
                    />
                    <span>Lapa {pagination.page} no {pagination.totalPages}</span>
                    <ButtonPrimary
                        text="Nākamā"
                        onClick={() => onPageChange(pagination.page + 1)}
                        disabled={pagination.page >= pagination.totalPages}
                    />
                </div>
            </div>
        </div>
    );
}

export default OrderList;
